module.exports = __webpack_public_path__ + "media/images/benefit-02-597fe5c1cec6c7ca55a8af7f3671670a.svg";